import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class MultaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getMultas() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/multas')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getMulta(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/multas/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaMulta(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/multas', {
				usuario_id: data.usuario_id,
				veiculo_id: data.veiculo_id,
				profissional_id: data.profissional_id,
				tipo_multa_id: data.tipo_multa_id,
				multa_data_infracao: data.multa_data_infracao,
				multa_data_notificacao: data.multa_data_notificacao,
				multa_data_transferencia: data.multa_data_transferencia,
				multa_data_vencimento: data.multa_data_vencimento,
				multa_descricao: data.multa_descricao,
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id
				/*multa_natureza: 5, //data.multa_natureza,
				multa_pontuacao: 5, //data.multa_pontuacao,
				multa_situacao: 5, //data.multa_situacao,*/
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaMulta(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/multas/' + data.multa_id, {
				usuario_id: data.usuario_id,
				veiculo_id: data.veiculo_id,
				profissional_id: data.profissional_id,
				tipo_multa_id: data.tipo_multa_id,
				multa_data_infracao: data.multa_data_infracao,
				multa_data_notificacao: data.multa_data_notificacao,
				multa_data_transferencia: data.multa_data_transferencia,
				multa_data_vencimento: data.multa_data_vencimento,
				multa_descricao: data.multa_descricao,
				cliente_id: data.cliente_id,
				unidade_id: data.unidade_id
				/*multa_natureza: data.multa_natureza,
				multa_pontuacao: data.multa_pontuacao,
				multa_situacao: data.multa_situacao,*/
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaMulta(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/multas/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getByUsuario(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/multas/usuario/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
